import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import './Return.css';

const Return: React.FC = () => {
  const [status, setStatus] = useState<string>('loading');
  const [sessionId, setSessionId] = useState<string>('');

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionIdParam = urlParams.get('session_id');

    if (sessionIdParam) {
      setSessionId(sessionIdParam);

      // Save booking to database
      fetch('https://api.theacademicloft.com/save-booking', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          sessionId: sessionIdParam
        })
      })
        .then(response => response.json())
        .then(data => {
          console.log('Booking saved:', data);
          setStatus('complete');
        })
        .catch(error => {
          console.error('Error saving booking:', error);
          // Still show success to user even if saving fails
          setStatus('complete');
        });
    } else {
      setStatus('error');
    }
  }, []);

  if (status === 'loading') {
    return (
      <div className="return-container">
        <div className="return-content">
          <div className="loading-spinner"></div>
          <h2>Processing...</h2>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="return-container">
      <div className="return-content success">
        <div className="success-icon">✓</div>
        <h1>Booking Confirmed!</h1>
        <p className="success-message">
          Thank you for your reservation. Your booking has been confirmed and a confirmation email
          has been sent to your email address.
        </p>
        <div className="session-info">
          <p className="session-id">Confirmation #: {sessionId.slice(-12).toUpperCase()}</p>
        </div>
        <div className="next-steps">
          <h3>What's Next?</h3>
          <ul>
            <li>Check your email for booking details and check-in instructions</li>
            <li>Save your confirmation number for reference</li>
            <li>We'll send you a reminder closer to your check-in date</li>
          </ul>
        </div>
        <button
          onClick={() => window.location.href = '/'}
          className="home-button"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default Return;
